var map = {
	"./assets-overview-selected.svg": 50527,
	"./assets-overview.svg": 19715,
	"./bank-account-selected.svg": 12876,
	"./bank-account.svg": 87982,
	"./bank.svg": 9856,
	"./basic-info-selected.svg": 21709,
	"./basic-info.svg": 40445,
	"./buy-properties-selected.svg": 26538,
	"./buy-properties.svg": 54728,
	"./dollar.svg": 90100,
	"./events-selected.svg": 23617,
	"./events.svg": 95073,
	"./expand-menu.svg": 95486,
	"./golearn-selected.svg": 7284,
	"./golearn.svg": 38470,
	"./info.svg": 78658,
	"./key-selected.svg": 95267,
	"./key.svg": 85543,
	"./kyc-selected.svg": 24297,
	"./kyc.svg": 91033,
	"./my-account-selected.svg": 9812,
	"./my-account.svg": 82278,
	"./notification-active.svg": 87798,
	"./notification.svg": 30935,
	"./password-menu-selected.svg": 1755,
	"./password-menu.svg": 87119,
	"./password.svg": 15849,
	"./pending-action-selected.svg": 98200,
	"./pending-action.svg": 81546,
	"./pin-selected.svg": 31635,
	"./pin.svg": 96087,
	"./referrals-selected.svg": 34750,
	"./referrals.svg": 51852,
	"./rental-income-selected.svg": 11298,
	"./rental-income.svg": 92016,
	"./security-selected.svg": 96682,
	"./security.svg": 90888,
	"./shrink-menu.svg": 72467,
	"./transaction-selected.svg": 16044,
	"./transaction.svg": 44398,
	"./two-factor-auth-selected.svg": 56251,
	"./two-factor-auth.svg": 48495,
	"./user.svg": 37379,
	"./warning-message.svg": 69572,
	"./withdrawal-history-selected.svg": 78230,
	"./withdrawal-history.svg": 74068,
	"./withdrawals-selected.svg": 4448,
	"./withdrawals.svg": 74370,
	"./yearly-summary-selected.svg": 71083,
	"./yearly-summary.svg": 45055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82002;